import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

const OrganizationsPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Organizasyonlar" />
      <div className="card">
        <div className="card-body">
          <h5>Organizasyonlar</h5>
          <p>Bu sayfa yakında eklenecek.</p>
        </div>
      </div>
    </MasterLayout>
  );
};

export default OrganizationsPage;

